import React, { useEffect, useState } from 'react';
import { AlertaIcono, AlertaIdentidad, AlertaTexto } from './styles';
import { BsExclamation, BsCheckCircle, BsXCircleFill, BsInfoCircleFill, BsCheck } from 'react-icons/bs'; 
// Si decidiste usar FiCheckCircle:
// import { FiCheckCircle } from 'react-icons/fi'; 
import colors from '../../assets/styles/colors';
import { getDataValidacion } from '../../services/IdentityValidation';

const AlertaValidacionIdentidad = ({ idCredito }) => {
  const [validacionData, setValidacionData] = useState(null);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);

  async function obtenerEstadoValidacion() {
    if (idCredito) {
      const response = await getDataValidacion(idCredito);
      if (response && response.data) {
        setValidacionData(response.data);
        setMostrarAlerta(true); 
      } else {
        setMostrarAlerta(false);
      }
    } else {
      setMostrarAlerta(false);
    }
  }

  useEffect(() => {
    obtenerEstadoValidacion();
  }, [idCredito]);

  const getAlertaProps = () => {
    if (!validacionData) return {};

    const { estadoValidacion, intentoValidacion } = validacionData;
    let backgroundColor, borderColor, textColor, icon, message;

    // Prioridad: Primero verificamos si intentoValidacion > 3, ya que es una condición específica
    if (intentoValidacion >= 3 && estadoValidacion == 'PENDIENTE') {
      backgroundColor = colors.alertaNaranjaFondo;
      borderColor = colors.alertaNaranjaBorde;
      textColor = colors.black;
      icon = <BsExclamation size={32} color={colors.black} />;
      message = 'Validación de identidad Who is Who pendiente.';
      return { backgroundColor, borderColor, textColor, icon, message }; 
    }

    switch (estadoValidacion) {
      case 'PENDIENTE':
        backgroundColor = colors.alertaAmarilloFondo;
        borderColor = colors.alertaAmarilloBorde;
        textColor = colors.black;
        icon = <BsExclamation size={32} color={colors.black} />;
        message = 'Validación de identidad pendiente.';
        break;
      case 'RECHAZADA':
        backgroundColor = colors.alertaRojoFondo;
        borderColor = colors.alertaRojoBorde;
        textColor = colors.black;
        icon = <BsExclamation size={32} color={colors.black} />;
        message = 'Validación de identidad rechazada.';
        break;
      case 'EXITOSA':
        backgroundColor = colors.alertaVerdeFondo;
        borderColor = colors.alertaVerdeBorde;
        textColor = colors.black;
        icon = <BsCheckCircle size={32} color={colors.black} />; 
        message = 'Validación de identidad exitosa.';
        break;
      default:
        backgroundColor = '#fffbea';
        borderColor = '#f6c343';
        textColor = colors.black;
        icon = <BsCheck size={32} color={colors.black} />;
        message = 'Estado de validación desconocido o no especificado.';
    }
    return { backgroundColor, borderColor, textColor, icon, message };
  };

  const { backgroundColor, borderColor, textColor, icon, message } = getAlertaProps();

  return (
    <>
      {mostrarAlerta && validacionData && (
        <AlertaIdentidad $backgroundColor={backgroundColor} $borderColor={borderColor}>
          <AlertaIcono $backgroundColor={borderColor}>
            {icon}
          </AlertaIcono>
          <AlertaTexto $textColor={textColor}>{message}</AlertaTexto>
        </AlertaIdentidad>
      )}
    </>
  );
};

export default AlertaValidacionIdentidad;